<template>
  <div>
    <div class="resource-section" v-if="fixedResources.length">
      <h2 class="title">{{ $t('resourcesPage.otherResourcesTitle') }}</h2>
      <div class="stats">
        <linear-chart v-for="(bar, index) in fixedResources"
                      :key="'other'+index"
                      :label="bar.info"
                      :max-value="bar.value"
                      :current-value="bar.remainingValue"
                      :animation-delay="index/4"
                      :unlimited="bar.remainingValue === '-1'"
                      :value-label="getValueLabel(bar.remainingValue, bar.value, bar.unitOfMeasure)">
          <p slot="value" class="value-label" v-if="Number(bar.remainingValue) >= 0">{{bar.remainingValue}} / <span class="text-muted">{{ bar.value }} {{getUnitOfMeasure(bar.unitOfMeasure)}}</span></p>
        </linear-chart>
      </div>
    </div>
    <p class="note" v-if="fixedResources.length">{{ $t('resourcesPage.currentMonthNote') }}</p>
  </div>
</template>

<script>
import LinearChart from '@/components/common/linear-chart'

export default {
  name: 'fixed-resources',
  components: { LinearChart },
  props: {
    resourcesData: {
      type: Object,
      default: () => {
        return {}
      },
      required: true
    }
  },
  computed: {
    fixedResources () {
      const res = Object.keys(this.$props.resourcesData).length && this.$props.resourcesData.averageServiceUsages.filter(resource => resource)
      if (res.length) return res[0].resources ? res[0].resources : []
      return []
    }
  },
  methods: {
    getValueLabel (remainingValue, maxValue, unit) {
      if (Number(remainingValue) < 0) return 'Neograničeno'

      // uncomment if they decide to use GB instead of MB
      /* if (unit === 'MByte' && Number(maxValue) > 1024) {
        const maxVGB = Math.round(Number(maxValue) / 1024)
        const remVGB = Math.round(Number(maxValue) / 1024)
        const newUnit = 'GB'
        return `${remVGB}/${maxVGB} ${newUnit}`
      } */

      const newUnit = this.getUnitOfMeasure(unit)

      return `${remainingValue}/${maxValue} ${newUnit}`
    },
    getUnitOfMeasure (unit) {
      if (unit.toLowerCase() === 'mbyte') return 'MB'
      else if (unit.toLowerCase() === 'msg') return 'SMS'
      return unit
    }
  }
}
</script>

<style scoped lang="scss">
.resource-section {
  color: $text;
  padding-top: 2rem;

  .title {
    font-size: 2.4rem;
    font-weight: normal;
    text-transform: uppercase;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid $form-border-color;
  }

  .stats {
    padding: 1rem 0 2rem;
  }

  .value-label {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 0;
  }

  .text-muted {
    font-weight: $dark-grey;
  }
}

.note {
  font-size: 1.2rem;
  color: $dark-grey;

  &::before {
    content: '*';
    color: $primary;
    margin-right: .5rem;
  }
}
</style>
